export default `
mutation UpdateDivision($input: UpdateDivisionInput!) {
  updateDivision(input: $input) {
    divisionId
    displayName
    updatedAt
    serviceProviderId
    isDeleted
  }
}
`;